function focusAndOpenKeyboard(e, o) {
	if ((o || (o = 100), e)) {
		var a = document.createElement("input");
		(a.style.position = "absolute"),
			(a.style.top = $(document).scrollTop() + "px"),
			(a.style.left = "-1000px"),
			(a.style.height = 0),
			(a.style.opacity = 0),
			document.body.appendChild(a),
			a.focus(),
			setTimeout(function () {
				e.focus(), e.click(), document.body.removeChild(a);
			}, o);
	}
}

function debounce(func, delay) {
	let timeout;
	return function (...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), delay);
	};
}

function fetchSearchResults($element) {
	var keyword = $element.val();
	var loader_html = ajax_object.html_loader;
	if (keyword == "") {
		$("#datafetch").html("");
	} else if (keyword.length < 3) {
		$("#datafetch").html('<div class="results advice">' + ajax_object.min_string_length_text + "</div>");
	} else {
		$("#datafetch").html('<div class="results loading">' + ajax_object.loader_html + "</div>");
		$.ajax({
			url: ajax_object.ajaxurl,
			type: "post",
			data: { action: "data_fetch", keyword: keyword },
			success: function (data) {
				$("#datafetch").html(data);
			},
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	const offcanvasSearchElement = document.getElementById("offcanvasSearchForm");
	const megaSearchContainer = document.querySelector(".mega-search-container");
	const megaSearchForm = megaSearchContainer.querySelector("form.search");
	const megaSearchTextInput = megaSearchContainer.querySelector(".search-input");
	const megaSearchSubmitButton = megaSearchContainer.querySelector(".search-submit");
	const bsOffcanvasSearchElement = bootstrap.Offcanvas.getOrCreateInstance(offcanvasSearchElement);

	// Mantiene il submit nativo per accessibilita (tasto Invio e fallback senza JS)
	megaSearchForm.addEventListener("submit", function () {});

	// Appena la finestra di ricerca viene mostrata va in focus l'input testuale
	offcanvasSearchElement.addEventListener("shown.bs.offcanvas", function () {
		focusAndOpenKeyboard(megaSearchTextInput);
	});

	// Applica debounce alla funzione di ricerca AJAX
	const debouncedFetchSearchResults = debounce(function () {
		fetchSearchResults($(this));
	}, 300); // Imposta un ritardo di 300 ms

	// Ascolta keyup sull'input per effettuare ricerca con debounce
	$(megaSearchTextInput).keyup(debouncedFetchSearchResults);
	$(megaSearchSubmitButton).click((event) => {
		event.preventDefault();
		fetchSearchResults($(megaSearchTextInput));
	});
});
